<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Find opportunities that suit your business</h2>
    <p>
      Asoko provides opportunities to companies seeking solutions to their financial, development, sustanability, and growth needs.
    </p>
    <div class="action-wrap">
      <a @click="openProposals" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Find Deals</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'proposals-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openProposals() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Proposals Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Proposals Block',
      })
      this.$router.push('/about/deals#opportunities')
    },
  },
}
</script>
